export const invalidCoordinatePrefix = (coordinate: string, prefix: string | undefined): boolean =>
  !!prefix &&
  prefix.length > 0 &&
  ((prefix.length > coordinate.length && !prefix.startsWith(coordinate)) ||
    (prefix.length <= coordinate.length && !coordinate.startsWith(prefix)));
